import clsx from "clsx"

import Badge from "@atoms/Badge/Badge"

import styles from "./ColorBadge.module.scss"
import { ColorBadgeProps } from "./ColorBadge.types"

export default function ColorBadge(props: ColorBadgeProps) {
    const { colorScheme, className, buttonClassName, ...rest } = props

    const badgeProps = {
        ...rest,
        className: clsx(styles[`${colorScheme}Base`], className),
        buttonClassName: clsx(styles[`${colorScheme}Button`], buttonClassName),
    }

    if (rest.variant === "icon") {
        const { iconClassName, ...restWithoutIcon } = rest
        return (
            <Badge
                {...restWithoutIcon}
                variant="icon"
                className={clsx(styles[`${colorScheme}Base`], className)}
                buttonClassName={clsx(styles[`${colorScheme}Button`], buttonClassName)}
                iconClassName={clsx(styles[`${colorScheme}Icon`], iconClassName)}
            />
        )
    } else {
        return <Badge {...badgeProps} />
    }
}
